import React, { memo } from 'react';
import { ButtonGroup as Group } from '@material-ui/core';
import './ButtonGroup.scss';

const ButtonGroup = ({ children, ...otherProps }) => {
  return <Group {...otherProps}>{children}</Group>;
};
const MemoizedButtonGroup = memo(ButtonGroup);
export default MemoizedButtonGroup;
